import configureStoreDev from './configureStore.dev.js';
import configureStoreProd from './configureStore.prod.js';
import { isDebugBuild } from '#config/shared';

export default function configureStore() {
  if (isDebugBuild) {
    return configureStoreDev();
  } else {
    return configureStoreProd();
  }
}
